import React from 'react';
import './ReadmePage.css';

function ReadmePage() {
  return (
    <div className="readme-page">
      <header>
        <h1>📘 Project README</h1>
        <p className="subtitle">Modular Identity System • React • Data Engineering • ETL</p>
      </header>

      <section className="readme-content">

        {/* Overview */}
        <h2>Overview</h2>
        <p>
          This project is a fully modular, containerized identity system engineered by <strong>Joseph W.P. Bodden Jr.</strong> — a developer who doesn’t just write code, he architects presence.  
          It’s a React‑driven résumé platform that redefines what a professional portfolio can be: dynamic, elegant, and alive. Every component — from the cover letter to the skills matrix — is a self‑contained module of precision, clarity, and design intent.  

          Built with <strong>Node 18‑alpine</strong>, <strong>Nginx</strong>, and a <strong>Dockerized deployment pipeline</strong>, this application runs anywhere — from local dev environments to cloud containers — proving that professional identity can be as portable, scalable, and resilient as any modern system.  
          It’s not just a résumé; it’s a living architecture of capability — a system that evolves with its creator.
        </p>

        {/* Architecture */}
        <h2>Architecture</h2>
        <ul>
          <li><strong>React Frontend:</strong> Functional components, scoped CSS, modular routing</li>
          <li><strong>Identity Modules:</strong> CoverLetter, Resume, SkillsSummary, HighlightReels</li>
          <li><strong>Backend Stack:</strong> Dockerized Flask API with Postgres (ETL Sandbox)</li>
          <li><strong>Deployment:</strong> Heroku (container & buildpack workflows)</li>
          <li><strong>Data Layer:</strong> SQL Server, Postgres</li>
        </ul>

        {/* Features */}
        <h2>Features</h2>
        <ul>
          <li>Dynamic résumé and cover letter components with print-safe layouts</li>
          <li>Technical Skills Summary powered by real certifications and toolsets</li>
          <li>Custom navigation system using NavButtons</li>
          <li>Modular identity vault for multi-version résumé management</li>
          <li>Heroku-ready structure for rapid deployment and updates</li>
        </ul>

        {/* Skill Integration */}
        <h2>Integrated Skill Domains</h2>
        <ul>
          <li><strong>SQL:</strong> T‑SQL, PostgreSQL SQL, SOQL, query optimization, ETL transformations</li>
          <li><strong>Python:</strong> Automation, API integration, ETL orchestration, data wrangling</li>
          <li><strong>Analytics:</strong> Power BI, Tableau, SSRS, KPI modeling</li>
          <li><strong>DevOps:</strong> Docker, Git, CI/CD fundamentals, containerized development</li>
        </ul>

        {/* Usage */}
        <h2>Usage</h2>
        <p>
          Navigate using the top-level buttons to explore each identity module. Every page is optimized 
          for readability and printing. The Print button automatically hides itself during print operations 
          to ensure clean, professional output.
        </p>

        {/* Roadmap */}
        <h2>Roadmap</h2>
        <ul>
          <li>PDF export and downloadable résumé packets</li>
          <li>Dynamic form-driven résumé builder with versioning</li>
          <li>Identity Vault with UPC-style routing for multi-profile switching</li>
          <li>Automated deployment pipeline for résumé updates</li>
        </ul>

        {/* Author */}
        <h2>Author</h2>
        <p>
          <strong>Joseph W.P. Bodden Jr.</strong><br />
          Data & Technology Consultant • ETL Architecture • Full‑Stack Development<br />
          <a href="mailto:joeitguy@gmail.com">joeitguy@gmail.com</a> • Poway, CA
        </p>
      </section>
    </div>
  );
}

export default ReadmePage;
